const VO_FUNNEL_KEY = 'lingochat_vo_funnel'

// Whether this browser has ever entered the "vo" funnel. Like the trial flag it
// is sticky: once set it is never cleared, so come-back visitors who later
// arrive through the normal funnel are still served the vo pricing page.
export function isVoFunnel(): boolean {
  return localStorage.getItem(VO_FUNNEL_KEY) === 'true'
}

export function markVoFunnel(): void {
  localStorage.setItem(VO_FUNNEL_KEY, 'true')
}
